import {showError} from 'perform-base/js/flashes';

function queryQuickBooks() {
  var form = $('.query-form');

  form.submit(function(e) {
    e.preventDefault();
    var query = form.find('input').val().trim();
    if (!query) {
      showError('Please enter a query.');
      return;
    }

    $.ajax({
      url: document.location,
      method: 'POST',
      data: {
        query,
      }
    }).then((response) => {
      $('.summary').html((response.length || 0) + (response.length === 1 ? ' result' : ' results'));
      $('.results').html(JSON.stringify(response, null, 2));
    }).catch((error) => {
      $('.summary').html('<span class="text-danger">Error</span>');
      $('.results').html(error.responseJSON.quickBooksResponse);
    });
  });
}

export {queryQuickBooks};



// WEBPACK FOOTER //
// ./assets/js/quickbooks.js